import { defineMessages } from 'react-intl';

export default defineMessages({
  higher: {
    id: 'cboard.components.Settings.Speech.higher',
    defaultMessage: 'Higher'
  },
  lower: {
    id: 'cboard.components.Settings.Speech.lower',
    defaultMessage: 'Lower'
  },
  faster: {
    id: 'cboard.components.Settings.Speech.faster',
    defaultMessage: 'Faster'
  },
  slower: {
    id: 'cboard.components.Settings.Speech.slower',
    defaultMessage: 'Slower'
  },
  pitch: {
    id: 'cboard.components.Settings.Speech.pitch',
    defaultMessage: 'Pitch'
  },
  pitchDescription: {
    id: 'cboard.components.Settings.Speech.pitchDescription',
    defaultMessage: 'Make the voice use a higher or lower pitch'
  },
  rate: {
    id: 'cboard.components.Settings.Speech.rate',
    defaultMessage: 'Rate'
  },
  rateDescription: {
    id: 'cboard.components.Settings.Speech.rateDescription',
    defaultMessage: 'Make the voice speak faster or slower'
  },
  speech: {
    id: 'cboard.components.Settings.Speech.speech',
    defaultMessage: 'Speech'
  },
  sampleSentence: {
    id: 'cboard.components.Settings.Speech.sampleSentence',
    defaultMessage: 'Hi! This is my voice.'
  },
  voice: {
    id: 'cboard.components.Settings.Speech.voice',
    defaultMessage: 'Voice'
  },
  elevenLabsApiKey: {
    id: 'cboard.components.Settings.Speech.elevenLabsApiKey',
    defaultMessage: 'ElevenLabs'
  },
  elevenLabsApiKeyDescription: {
    id: 'cboard.components.Settings.Speech.elevenLabsApiKeyDescription',
    defaultMessage: 'Enter your ElevenLabs API key'
  },
  elevenLabsApiKeyInvalid: {
    id: 'cboard.components.Settings.Speech.elevenLabsApiKeyInvalid',
    defaultMessage: 'Invalid API key format'
  },
  elevenLabsApiKeyUnauthorized: {
    id: 'cboard.components.Settings.Speech.elevenLabsApiKeyUnauthorized',
    defaultMessage: 'API key unauthorized or expired'
  },
  elevenLabsTestSuccess: {
    id: 'cboard.components.Settings.Speech.elevenLabsTestSuccess',
    defaultMessage: 'API key validated successfully'
  },
  elevenLabsTestError: {
    id: 'cboard.components.Settings.Speech.elevenLabsTestError',
    defaultMessage: 'Failed to validate API key'
  },
  elevenLabsStability: {
    id: 'cboard.components.Settings.Speech.elevenLabsStability',
    defaultMessage: 'Stability'
  },
  elevenLabsStabilityDescription: {
    id: 'cboard.components.Settings.Speech.elevenLabsStabilityDescription',
    defaultMessage: 'Determines how stable the voice is.'
  },
  elevenLabsSimilarity: {
    id: 'cboard.components.Settings.Speech.elevenLabsSimilarity',
    defaultMessage: 'Similarity'
  },
  elevenLabsSimilarityDescription: {
    id: 'cboard.components.Settings.Speech.elevenLabsSimilarityDescription',
    defaultMessage: 'Enhances similarity to the original voice.'
  },
  elevenLabsStyle: {
    id: 'cboard.components.Settings.Speech.elevenLabsStyle',
    defaultMessage: 'Style'
  },
  elevenLabsStyleDescription: {
    id: 'cboard.components.Settings.Speech.elevenLabsStyleDescription',
    defaultMessage: 'Determines the style exaggeration of the voice.'
  },
  resetToDefaults: {
    id: 'cboard.components.Settings.Speech.resetToDefaults',
    defaultMessage: 'Reset to Defaults'
  },
  elevenLabsApiKeyHelp: {
    id: 'cboard.components.Settings.Speech.elevenLabsApiKeyHelp',
    defaultMessage:
      'Get your API key from {elevenLabsLink} and enter it to enable your voices'
  }
});
